import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import { Icon, Grid } from "semantic-ui-react";
import auth from "../../services/authService";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { saveEntryType } from "../../services/accountLedgerService";

class LedgerNetBalance extends Component {
  state = {
    accountShow: "none",
    visaShow: "none",
    vehicleShow: "none",
    yardShow: "none",
    roomShow: "none",
    url: "",
  };

  projectUpdate = async (id) => {
    var selectedValue = document.getElementById("entry_type" + id).value;

    const verifyData = {
      selectedValue: selectedValue,
      id: id,
    };

    try {
      await saveEntryType(verifyData);
      toast.success("Entry Type has been updated successfully.");
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        // toast.warning("Hours should be only numbers");
      }
    }
  };

  componentDidMount() {
    const { payments, onDelete, onUpdate, visaid, type, info } = this.props;
    var url;

    if (type == "private-account") {
      url = "/private-accounts/" + visaid + "/document/new/";
      this.setState({ accountShow: "block", url });
    }
    if (type == "account") {
      url = "/accounts/" + visaid + "/document/new/";
      this.setState({ accountShow: "block", url });
    }
    if (type == "visa") {
      url = "/visas-accounts/" + visaid + "/document/new/";
      this.setState({ visaShow: "block", url });
    }
    if (type == "vehicle") {
      url = "/vehicles-accounts/" + visaid + "/document/new/";
      this.setState({ vehicleShow: "block", url });
    }
    if (type == "yard") {
      url = "/yards-accounts/" + visaid + "/document/new/";
      this.setState({ yardShow: "block", url });
    }
    if (type == "room") {
      url = "/rooms-accounts/" + visaid + "/document/new/";
      this.setState({ roomShow: "block", url });
    }
  }
  render() {
    var url = this.state.url;
    const { payments, onDelete, onUpdate, visaid, type, info } = this.props;

    let sr = 1;

    let netBalance = 0;
    return (
      <React.Fragment>
        <Table celled>
          <Table.Row>
            <Table.Cell colSpan="8" style={{ backgroundColor: "#eeeeee" }}>
              <Grid
                columns={2}
                divided
                style={{ display: this.state.accountShow }}
              >
                <Grid.Row>
                  <Grid.Column>
                    <Table definition>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell width={4}>Passport</Table.Cell>
                          <Table.Cell>{info.passport_number}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell width={4}>Emirates Id</Table.Cell>
                          <Table.Cell>{info.identification_id}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Grid.Column>
                  <Grid.Column>
                    <Table definition>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell width={4}>Mobile</Table.Cell>
                          <Table.Cell>{info.mobile}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell width={4}>Name</Table.Cell>
                          <Table.Cell>{info.name}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Grid.Column>
                </Grid.Row>
              </Grid>

              <Grid
                columns={2}
                divided
                style={{ display: this.state.visaShow, marginTop: "0px" }}
              >
                <Grid.Row>
                  <Grid.Column>
                    <Table definition>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell width={4}>Name</Table.Cell>
                          <Table.Cell>{info.name}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell width={4}>Mobile</Table.Cell>
                          <Table.Cell>{info.mobile}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Grid.Column>
                  <Grid.Column>
                    <Table definition>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell width={4}>Emirates Id</Table.Cell>
                          <Table.Cell>
                            {info.identification_id}
                            {info.emirates_id}
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell width={4}></Table.Cell>
                          <Table.Cell></Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Grid.Column>
                </Grid.Row>
              </Grid>

              <Grid
                columns={2}
                divided
                style={{ display: this.state.vehicleShow, marginTop: "0px" }}
              >
                <Grid.Row>
                  <Grid.Column>
                    <Table definition>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell width={4}>Plate Number</Table.Cell>
                          <Table.Cell>{info.plat_number}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell width={4}>Name</Table.Cell>
                          <Table.Cell>{info.name}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Grid.Column>
                  <Grid.Column>
                    <Table definition>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell width={4}>Mobile</Table.Cell>
                          <Table.Cell>{info.mobile}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell width={4}>Emirates Id</Table.Cell>
                          <Table.Cell>{info.emirates_id}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Grid.Column>
                </Grid.Row>
              </Grid>

              <Grid
                columns={2}
                divided
                style={{ display: this.state.yardShow, marginTop: "0px" }}
              >
                <Grid.Row>
                  <Grid.Column>
                    <Table definition>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell width={4}>Name</Table.Cell>
                          <Table.Cell>{info.name}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell width={4}>Mobile</Table.Cell>
                          <Table.Cell>{info.mobile}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Grid.Column>
                  <Grid.Column>
                    <Table definition>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell width={4}>Rent</Table.Cell>
                          <Table.Cell>{info.rent}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell width={4}>Emirate Id</Table.Cell>
                          <Table.Cell>{info.emirates_id}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Grid.Column>
                </Grid.Row>
              </Grid>

              <Grid
                columns={2}
                divided
                style={{ display: this.state.roomShow, marginTop: "0px" }}
              >
                <Grid.Row>
                  <Grid.Column>
                    <Table definition>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell width={4}>Name</Table.Cell>
                          <Table.Cell>{info.name}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell width={4}>Mobile</Table.Cell>
                          <Table.Cell>{info.mobile}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Grid.Column>
                  <Grid.Column>
                    <Table definition>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell width={4}>rent</Table.Cell>
                          <Table.Cell>{info.rent}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell width={4}>Room #</Table.Cell>
                          <Table.Cell>{info.room_number}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell width={4}>Emirates Id </Table.Cell>
                          <Table.Cell>{info.emirates_id}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Table.Cell>
          </Table.Row>

          <Table.Row>
            <Table.HeaderCell
              width={1}
              style={{
                textAlign: "center",
                height: "40px",
                backgroundColor: "#ddd",
              }}
            >
              Sr#
            </Table.HeaderCell>
            <Table.HeaderCell
              width={1}
              style={{
                textAlign: "center",
                height: "40px",
                backgroundColor: "#ddd",
              }}
            >
              Date
            </Table.HeaderCell>
            <Table.HeaderCell
              width={6}
              style={{ height: "40px", backgroundColor: "#ddd" }}
            >
              Description
            </Table.HeaderCell>
            <Table.HeaderCell
              width={2}
              style={{
                textAlign: "center",
                height: "40px",
                backgroundColor: "#ddd",
              }}
            >
              Debit
            </Table.HeaderCell>
            <Table.HeaderCell
              width={2}
              style={{
                textAlign: "center",
                height: "40px",
                backgroundColor: "#ddd",
              }}
            >
              Credit
            </Table.HeaderCell>
            <Table.HeaderCell
              width={2}
              style={{
                textAlign: "center",
                whiteSpace: "pre-line",
                height: "40px",
                backgroundColor: "#ddd",
              }}
            >
              Net Balance
            </Table.HeaderCell>
            <Table.HeaderCell
              width={1}
              style={{
                textAlign: "center",
                whiteSpace: "pre-line",
                height: "40px",
                backgroundColor: "#ddd",
              }}
            >
              File
            </Table.HeaderCell>
            <Table.HeaderCell
              width={1}
              style={{ height: "40px", backgroundColor: "#ddd" }}
            ></Table.HeaderCell>
          </Table.Row>

          <Table.Body>
            {payments.map((payment) => (
              <Table.Row key={payment.id}>
                <Table.Cell style={{ textAlign: "center" }}>{sr++}</Table.Cell>
                <Table.Cell style={{ textAlign: "center" }}>
                  {payment.payment_date}
                </Table.Cell>
                <Table.Cell>
                  <div style={{ whiteSpace: "pre-line" }}>
                    {payment.description}
                  </div>
                  <br />
                  {type == "account" ? (
                    <select
                      id={"entry_type" + payment.id}
                      onChange={() => this.projectUpdate(payment.id)}
                    >
                      <option value="">Select option</option>
                      <option
                        value="local"
                        selected={
                          payment.entry_type === "local" ? "selected" : ""
                        }
                      >
                        Local
                      </option>
                      <option
                        value="general"
                        selected={
                          payment.entry_type === "general" ? "selected" : ""
                        }
                      >
                        General
                      </option>
                    </select>
                  ) : (
                    ""
                  )}
                </Table.Cell>
                <Table.Cell style={{ textAlign: "center" }}>
                  {payment.debit}
                </Table.Cell>
                <Table.Cell style={{ textAlign: "center" }}>
                  {payment.credit}
                </Table.Cell>
                <Table.Cell style={{ textAlign: "center" }}>
                  {payment.credit > 0
                    ? Math.round(
                        (netBalance = netBalance + parseFloat(payment.credit)),
                        2
                      ) < 0
                      ? parse(
                          "<span style='color:green'>" +
                            Math.round(netBalance.toString().replace("-", "")) +
                            "</span>"
                        )
                      : parse(
                          "<span style='color:red'>(" +
                            netBalance.toFixed(2) +
                            ")</span>"
                        )
                    : Math.round(
                        (netBalance = netBalance - parseFloat(payment.debit)),
                        2
                      ).toFixed(2) < 0
                    ? parse(
                        "<span style='color:green'>" +
                          Math.round(
                            netBalance.toString().replace("-", ""),
                            2
                          ).toFixed(2) +
                          "</span>"
                      )
                    : parse(
                        "<span style='color:red'>(" +
                          Math.round(netBalance, 2).toFixed(2) +
                          ")</span>"
                      )}
                </Table.Cell>
                {payment.visa_ledger_id == 0 || payment.visa_ledger_id == "" ? (
                  <Table.Cell
                    style={{ backgroundColor: "red", color: "white" }}
                  >
                    <Link to={url + payment.id} className="ui">
                      <Icon name="plus" color="blue" className="clickable" />
                    </Link>
                  </Table.Cell>
                ) : payment.document != "" ? (
                  <Table.Cell style={{ color: "white", textAlign: "center" }}>
                    <a
                      style={{
                        color: "white",
                        backgroundColor: "green",
                        paddingLeft: "14px",
                        paddinRight: "14px",
                        height: "8px",
                      }}
                      target="_blank"
                      href={
                        process.env.REACT_APP_BACKEND_URL +
                        "/storage/" +
                        payment.document
                      }
                    >
                      &nbsp;
                      {/* <Icon name="download" color="white" className="clickable" /> */}
                    </a>
                    <br />
                    <Link to={url + payment.id} className="ui">
                      <Icon name="edit" color="blue" className="clickable" />
                    </Link>
                  </Table.Cell>
                ) : (
                  <Table.Cell style={{ textAlign: "center" }}>
                    {/* {auth.getCurrentUser().email === "company-unblocker@gondalgroup.ae" && ( */}
                    <Link
                      to={url + payment.id}
                      className="ui"
                      style={{
                        backgroundColor: "red",
                        color: "white",
                        paddingLeft: "14px",
                        paddinRight: "14px",
                        height: "8px",
                      }}
                    >
                      &nbsp;
                    </Link>

                    {/* )} */}
                  </Table.Cell>
                )}
                <Table.Cell>
                  {auth.getCurrentUser().email ===
                    "company-unblocker@gondalgroup.ae" && (
                    <div>
                      <Icon
                        name="trash"
                        color="red"
                        className="clickable"
                        onClick={() => onDelete(payment)}
                      />

                      <Icon
                        name="edit"
                        color="blue"
                        className="clickable"
                        onClick={() => onUpdate(payment)}
                      />
                    </div>
                  )}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>{" "}
      </React.Fragment>
    );
  }
}

export default LedgerNetBalance;
